/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inbound/view.blocks to change it.
import Attachments from './Attachments/index'
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import Message from './Message/index'
import React from 'react'
import Secure from './Secure/index'
import SentTime from './SentTime/index'
import User from './User/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Inbound({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/InApp/Content/Inbound"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginLeft={0}
 alignSelf="flex-start"
 alignItems="flex-start"
 backgroundColor="rgba(19,126,197,0.1)"
>
{childProps => (
<React.Fragment>
<Message
{...childProps}
  viewPath={`${viewPath}/Message`}
/>
<div
  data-testid="Inbound.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<User
  viewPath={`${viewPath}/User`}
/>
<SentTime
  viewPath={`${viewPath}/SentTime`}
/>
<Secure
  viewPath={`${viewPath}/Secure`}
/>
</div>
<Attachments
{...childProps}
  viewPath={`${viewPath}/Attachments`}
/>
</React.Fragment>
)}
</CardMessageNoAvatar>
{children}
</React.Fragment>)
}